import React from 'react';
import { Plus, Minus } from 'lucide-react';
export function CanvasToolbar() {
  return <div className="flex items-center gap-4 bg-white rounded-lg shadow-sm border border-gray-200 px-4 py-2" data-id="element-12">
      <div className="flex items-center gap-2" data-id="element-13">
        <button className="p-1 hover:bg-gray-100 rounded text-gray-500" data-id="element-14">
          <Minus size={16} data-id="element-15" />
        </button>
        <span className="text-sm font-medium text-gray-700 min-w-[40px] text-center" data-id="element-16">
          50%
        </span>
        <button className="p-1 hover:bg-gray-100 rounded text-gray-500" data-id="element-17">
          <Plus size={16} data-id="element-18" />
        </button>
      </div>
      <div className="h-4 w-px bg-gray-200" data-id="element-19" />
      <button className="text-sm text-gray-500 hover:text-gray-900" data-id="element-20">
        Reset
      </button>
    </div>;
}